import React, { useCallback } from "react";

import { twMerge } from "tailwind-merge";

import { SKSpinner } from "components/customElements/skSpinner";
import TopNavBarSearchSnippet from "components/TopNavBar/TopNavBarSearchSnippet";
import highLightText from "utils/highLightText";
import shortSecurity from "utils/shortSecurity";

import styles from "../styles.module.scss";

const SuggestionSnippet = ({
  mention: data,
  isFocused,
  selectMention,
  searchValue: query,
  onMouseDown,
  onMouseUp,
  onMouseEnter,
}: any) => {
  const onClick = useCallback(
    (event?: React.MouseEvent) => {
      event?.preventDefault();
      event?.stopPropagation();

      selectMention(data);
    },
    [data, selectMention]
  );

  const className = twMerge(
    isFocused ? "bg-[#eee] text-smart-teal" : "",
    "border-0 border-b border-solid border-inactive-gray",
    "px-[15px] py-[5px] cursor-pointer",
    "truncate max-w-[600px]",
    "group flex items-center"
  );

  const props = {
    onMouseDown,
    onMouseUp,
    onMouseEnter,
  };

  if (data.type === "placeholder") {
    return (
      <div className="text-center text-inactive-gray text-[13px]">
        <div>Type to cite an {data.name}...</div>
        <div>
          <SKSpinner showLoading={false} />
        </div>
      </div>
    );
  }

  if (data.type === "placeholder-empty") {
    return (
      <div className="text-center text-inactive-gray text-[13px] italic">
        <div>No results found</div>
      </div>
    );
  }

  if (data.type === "insights") {
    const text = data.tagline;
    const highLightedText = query ? highLightText(text, query) : text;

    return (
      <div className="w-full relative" onClick={onClick} {...props}>
        <div className={twMerge(className)}>
          <span className="text-[13px]">{highLightedText}</span>
        </div>
      </div>
    );
  }

  if (data.type === "entities") {
    const text = `${data.prettyName} ${
      data?.security ? ` (${shortSecurity(data?.security)})` : ""
    }`;
    const highLightedText = query ? highLightText(text, query) : text;

    return (
      <div className="w-full relative" onClick={onClick} {...props}>
        <div className={twMerge(className)}>
          <span className="text-[13px]">{highLightedText}</span>
        </div>
      </div>
    );
  }

  if (data.type === "accounts" || data.type === "insight-providers") {
    const text = data.name;
    const highLightedText = query ? highLightText(text, query) : text;

    return (
      <div className="w-full relative" onClick={onClick} {...props}>
        <div className={twMerge(className)}>
          <span className="text-[13px]">{highLightedText}</span>
        </div>
      </div>
    );
  }

  if (data.type === "companies") {
    const text = data.name;
    const highLightedText = query ? highLightText(text, query) : text;

    return (
      <div className="w-full relative" onClick={onClick}>
        <div className={twMerge(className)}>
          <span className="text-[13px]">{highLightedText}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.suggestionSnippet}>
      <TopNavBarSearchSnippet
        data={data}
        highLighting={isFocused}
        query={query}
        disableNavigation
        onClick={onClick}
        {...props}
      />
    </div>
  );
};

export default SuggestionSnippet;
